import io from 'socket.io-client';

const socket = io('https://fast-shelf-59848.herokuapp.com');

export default socket;
